import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const TOPBAR_SLOT_ID = 'meridian-topbar-slot';

/**
 * Projette des contrôles de page dans la topbar du shell Méridien.
 *
 * Le sélecteur de période, la bascule compte commun/personnel… appartiennent
 * logiquement à la page (qui détient leur état) mais visuellement à la topbar.
 * Plutôt que de remonter cet état dans le layout, la page rend ses contrôles
 * ici et ils sont téléportés dans l'emplacement réservé.
 *
 * Rend `null` si l'emplacement n'existe pas (thèmes sidebar/topnav, où la page
 * garde ses contrôles en place) — l'appelant fournit alors son propre rendu.
 */
export default function TopbarPortal({ children }: { children: React.ReactNode }) {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // L'emplacement est monté par le layout ; on le résout après le premier
    // rendu, et on re-teste quand le thème change de structure de menu.
    setHost(document.getElementById(TOPBAR_SLOT_ID));
  }, []);

  if (!host) return null;
  return createPortal(children, host);
}

/** Indique si le shell courant expose une topbar capable d'accueillir des contrôles. */
export function useHasTopbarSlot(): boolean {
  const [has, setHas] = useState(false);
  useEffect(() => {
    setHas(!!document.getElementById(TOPBAR_SLOT_ID));
  });
  return has;
}
